import styled, { css } from 'styled-components';
import { Text, Box, SideSheetContentCol } from '@bechtel/gds';

export const BlockDetailContainer = styled(Box).attrs({ flexDirection: { sm: 'column' } })`
  width: 100%;
  height: 100vh;
  position: absolute;
`;

export const BlockCardHeaderWrapperStyled = styled.div`
  ${({ theme }) => css`
    padding: ${theme.spacings[600]} ${theme.spacings[600]} 0 ${theme.spacings[600]};
    background-color: ${theme.colors.white};
    box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 4px 5px 0 rgba(0, 0, 0, 0.14);
    z-index: 1; /* Header box shadow disappears when block image scrolls over the header */
  `}
`;

export const TextStyled = styled(Text)`
  max-width: 292px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  padding-bottom: 2px;
`;

export const MultiBlockSideSheetContentColStyled = styled(SideSheetContentCol)`
  box-shadow: 0 1px 5px 0 #00000033, 0 3px 1px -2px #0000001f, 0 2px 2px 0 #00000024;
  position: relative;
  z-index: 1;
`;
